/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Field, reduxForm, change } from 'redux-form';
import Select, { components } from 'react-select';
import InputMask from 'react-input-mask';
import StringMask from 'string-mask';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import ru from 'date-fns/locale/ru';
import 'react-datepicker/dist/react-datepicker.css';

import FixRequiredSelect from '../../helpers/fixReactSelect';
import { ReactComponent as ArrowIcon } from '../../assets/arrow.svg';
import { PAYMENTS } from '../../constans/payments';
import {
    switchPopupCreateAction,
    confirmPhoneSend,
    confirmPhoneCheck
} from './actions';
// import { setCreatingWriteWSAction } from './actionsWS';
import './style.scss';


const DropdownIndicator = props => (
    <components.DropdownIndicator {...props}>
        <ArrowIcon />
    </components.DropdownIndicator>
);

const SelectInput = ({ options, input, placeholder }, ...props) => (
    <FixRequiredSelect
        {...props}
        SelectComponent={Select}
        options={options}
        value={input.value}
        onChange={value => input.onChange(value)}
        onBlur={value => input.onBlur(value.value)}
        components={{ DropdownIndicator }}
        classNamePrefix="select-input"
        placeholder={placeholder}
        required
    />
);

const DatepickerInput = (props) => {
    const { input, placeholder } = props;
    let years = [];
    for (let i = 1950; i <= moment().year(); i++) {
        years = [...years, i];
    }
    const months = [
        'Январь',
        'Февраль',
        'Март',
        'Апрель',
        'Май',
        'Июнь',
        'Июль',
        'Август',
        'Сентябрь',
        'Октябрь',
        'Ноябрь',
        'Декабрь',
    ];

    const ExampleCustomInput = React.forwardRef((parentProps, ref) => (
        <InputMask
            ref={ref}
            mask="99.99.9999"
            maskChar="_"
            placeholder={parentProps.placeholder}
            onClick={parentProps.onClick}
            onKeyDown={parentProps.onKeyDown}
            onChange={parentProps.onChange}
            value={parentProps.value}
        />
    ));

    const ref = React.createRef();

    return (
        <DatePicker
            renderCustomHeader={({
                date,
                changeYear,
                changeMonth,
                decreaseMonth,
                increaseMonth,
                prevMonthButtonDisabled,
                nextMonthButtonDisabled,
            }) => (
            <div
                style={{
                    margin: 10,
                    display: 'flex',
                    justifyContent: 'space-between',
                }}
            >
                <button type="button" className="prev" onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>
                    <ArrowIcon />
                </button>
                <select
                value={moment(date).year()}
                onChange={({ target: { value } }) => changeYear(value)}
                >
                {years.map(option => (
                    <option key={option} value={option}>
                    {option}
                    </option>
                ))}
                </select>

                <select
                value={months[moment(date).month()]}
                onChange={({ target: { value } }) => changeMonth(months.indexOf(value))
                }
                >
                {months.map(option => (
                    <option key={option} value={option}>
                    {option}
                    </option>
                ))}
                </select>

                <button type="button" className="next" onClick={increaseMonth} disabled={nextMonthButtonDisabled}>
                    <ArrowIcon />
                </button>
            </div>
            )}
            customInput={<ExampleCustomInput />}
            selected={input.value !== '' ? moment(input.value).toDate() : null}
            onChange={date => input.onChange(moment(date).format('YYYY-MM-DD'))}
            locale={ru}
            dateFormat="dd.MM.yyyy"
            ref={ref}
            placeholderText={placeholder}
        />
    );
};

const MaskInput = ({
    input, mask, placeholder
}) => (
    <InputMask
        {...input}
        mask={mask}
        maskChar="_"
        placeholder={placeholder}
        alwaysShowMask
        onChange={value => input.onChange(value)}
        required
    />
);

class CreateForm extends React.Component {
    state = {
        timeLeft: 180,
        timerID: null,
        formConfirm: false,
        formWrite: null
    }

    componentDidMount() {
        const { dispatch, vk } = this.props;
        const { userInfo } = vk;
        const formatter = new StringMask('+0(000) 000-00-00');

        this.timer('START');

        dispatch(change('createWrite', 'last-name', userInfo.lastName ? userInfo.lastName : ''));
        dispatch(change('createWrite', 'first-name', userInfo.firstName ? userInfo.firstName : ''));
        dispatch(change('createWrite', 'phone', userInfo.phone ? formatter.apply(userInfo.phone) : ''));
        // dispatch(change('createWrite', 'birthday', userInfo.birthday ? userInfo.birthday : ''));
    }

    componentDidUpdate(prevProps) {
        const { schedule, handleSubmit } = this.props;
        const { schedule: prevScheule } = prevProps;

        const { confirmPhone } = schedule;
        const { confirmPhone: prevConfirmPhone } = prevScheule;

        if (confirmPhone.confirmed !== prevConfirmPhone.confirmed && confirmPhone.confirmed) {
            const { formWrite } = this.state;

            formWrite.dispatchEvent(new Event('submit'));
        }
    }

    componentWillUnmount() {
        this.timer('STOP');
    }

    timerToString = () => {
        const { timeLeft } = this.state;
        const seconds = timeLeft % 60;
        const minutes = parseInt(timeLeft / 60, 10);

        return `${minutes}:${seconds < 10 ? `0${seconds}` : seconds}`;
    }

    timer = (type) => {
        if (type === 'START') {
            const timerID = setInterval(() => {
                const { timeLeft } = this.state;
                const newTime = timeLeft - 1;
                if (newTime >= 0) {
                    this.setState({ timeLeft: newTime });
                } else {
                    const { timerID: sTimerID } = this.state;
                    const { dispatch, schedule } = this.props;
                    const { creatingData } = schedule;

                    clearInterval(sTimerID);
                    // setCreatingWriteWSAction('UNSET', creatingData.ticket, creatingData.doctor, 'anonym', ws);
                    dispatch(switchPopupCreateAction());
                }
            }, 1000);

            this.setState({ timerID });
        } else if (type === 'STOP') {
            const { timerID } = this.state;
            clearInterval(timerID);
            this.setState({ timerID: null, timeLeft: 120 });
        }
    }

    onSubmit = (e, type) => {
        const { handleSubmit, dispatch } = this.props;
        e.preventDefault();
        if (type === 'notConfirm') {
            handleSubmit(e);
        } else if (type === 'withConfirm') {
            e.persist();
            const formWrite = e.currentTarget;
            this.setState({ formConfirm: true, formWrite });
            this.timer('STOP');
            const phone = formWrite.querySelectorAll('input[name=phone]')[0].value;
            dispatch(confirmPhoneSend(phone));
        } else if (type === 'confirm') {
            const { formWrite } = this.state;
            const code = e.currentTarget.querySelectorAll('input[name=code]')[0].value;
            const phone = formWrite.querySelectorAll('input[name=phone]')[0].value;
            dispatch(confirmPhoneCheck(code, phone));
        }
    }

    render() {
        const { schedule } = this.props;
        const { formConfirm } = this.state;
        const { settings, confirmPhone } = schedule;
        const typeSubmit = settings.notify_check_phone && !confirmPhone.confirmed ? 'withConfirm' : 'notConfirm';

        return (
            <>
                <form
                    onSubmit={e => this.onSubmit(e, typeSubmit)}
                    className="schedule__popup__form"
                    style={{ display: formConfirm ? 'none' : 'block' }}
                >
                    <div className="schedule__popup__form_fio schedule__popup__form_field">
                        <label><span>*</span> Ф.И.О.:</label>
                        <br />
                        <Field name="last-name" component="input" type="text" placeholder="Фамилия" required />
                        <br />
                        <Field name="first-name" component="input" type="text" placeholder="Имя" required />
                        <br />
                        <Field name="second-name" component="input" type="text" placeholder="Отчество" required />
                    </div>
                    <div className="schedule__popup__form_field">
                        <label>ФИО преставителя:</label>
                        <br />
                        <Field name="representative" component="input" type="text" placeholder="ФИО представителя" />
                    </div>
                    <div className="two-columns">
                        <div className="schedule__popup__form_phone schedule__popup__form_field">
                            <label><span>*</span> Телефон:</label>
                            <br />
                            <Field name="phone" component={MaskInput} placeholder="+7(___)___-__-__" mask="+7(999) 999-99-99" />
                        </div>
                        <div className="schedule__popup__form_birthday schedule__popup__form_field">
                            <label><span>*</span> Дата рождения:</label>
                            <br />
                            <Field name="birthday" component={DatepickerInput} type="text" placeholder="Дата рождения" required />
                            {/* <Field name="birthday" component="input" type="date" required /> */}
                        </div>
                    </div>
                    <div className="schedule__popup__form_payment schedule__popup__form_field">
                        <label><span>*</span> Вариант оплаты:</label>
                        <br />
                        <Field name="payment-type" component={SelectInput} placeholder="Выберите вариант" options={PAYMENTS} />
                    </div>
                    <div className="schedule__popup__form_comments schedule__popup__form_field">
                        <label>Комментарии:</label>
                        <br />
                        <Field name="comments" component="textarea" placeholder="Комментарии к записи" />
                    </div>
                    <label className="policy">
                        <Field name="policy" component="input" type="checkbox" required />
                        <span>Нажимая на кнопку &quot;Записаться&quot;, Я даю согласие на <a href="https://new.vpriem.ru/privacy.pdf" rel="noreferrer" target="_blank">обработку персональных данных</a>.</span>
                    </label>
                    <button type="submit" className="btn schedule__popup__form_submit">Записаться</button>
                    <div className="schedule__popup__form_timer">Окончание брони через: <span>{this.timerToString()}</span></div>
                </form>
                {formConfirm && (
                    <form
                        onSubmit={e => this.onSubmit(e, 'confirm')}
                        className="schedule__popup__form confirm"
                        style={{ display: formConfirm ? 'block' : 'none' }}
                    >
                        <div className="schedule__popup__form_code schedule__popup__form_field">
                            <label>Код из СМС:</label>
                            <br />
                            <Field name="code" component={MaskInput} placeholder="____" mask="9999" />
                        </div>
                        <button type="submit" className="btn schedule__popup__form_submit">Подтвердить</button>
                    </form>
                )}
            </>
        );
    }
}

SelectInput.defaultProps = {
    placeholder: ''
};

SelectInput.propTypes = {
    input: PropTypes.object.isRequired,
    options: PropTypes.array.isRequired,
    placeholder: PropTypes.string
};

MaskInput.defaultProps = {
    placeholder: ''
};

MaskInput.propTypes = {
    input: PropTypes.object.isRequired,
    mask: PropTypes.string.isRequired,
    placeholder: PropTypes.string
};


CreateForm.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    dispatch: PropTypes.func.isRequired,
    schedule: PropTypes.object.isRequired,
    vk: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    schedule: state.schedule,
    vk: state.vk
});

const wrapper = compose(
    connect(mapStateToProps),
    reduxForm({ form: 'createWrite' })
);


export default wrapper(CreateForm);

// export default reduxForm({ form: 'createWrite' })(CreateForm);
